import { render, staticRenderFns } from "./unfreezeForm.vue?vue&type=template&id=64a3244b&scoped=true&"
import script from "./unfreezeForm.vue?vue&type=script&lang=js&"
export * from "./unfreezeForm.vue?vue&type=script&lang=js&"
import style0 from "./unfreezeForm.vue?vue&type=style&index=0&id=64a3244b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3244b",
  null
  
)

export default component.exports